<button
  class="k-button-icon k-button k-bare app-close-button"
  style="margin-left: auto"
  (click)="goToLoginPage()"
  title="{{ 'profile.default.close' | localize }}"
>
  <span class="k-icon k-i-close ng-star-inserted"></span>
</button>
<span class="label-box">{{ localizeBasePath + '.registration' | localize }}</span>
<kendo-stepper
  [steps]="steps"
  [(currentStep)]="current"
  [linear]="false"
  [style.width.px]="570"
  (currentStepChange)="onStepChange($event)"
>
</kendo-stepper>
<form *ngIf="form" [formGroup]="form">
  <div *ngIf="current === 0">
    <div formGroupName="profileInfo">
      <kendo-formfield class="field-group">
        <kendo-floatinglabel class="required" text="{{ localizeBasePath + '.citizenship' | localize }}">
          <kendo-combobox
            [appDropDownDataBinding]="actions.GetCitizenship"
            [data]="citizenships$ | async"
            [kendoDropDownFilter]="filterSettings"
            textField="name"
            valueField="id"
            formControlName="citizenship"
          >
          </kendo-combobox>
        </kendo-floatinglabel>
        <kendo-formerror *ngIf="getErrorOfField('profileInfo.citizenship', 'required') as error">
          {{ defaultErrors.required(error) }}</kendo-formerror
        >
      </kendo-formfield>
      <kendo-formfield class="field-group">
        <kendo-floatinglabel class="required" text="{{ localizeBasePath + '.birth_year' | localize }}">
          <kendo-numerictextbox formControlName="birthYear" format="0000" [min]="1910"></kendo-numerictextbox>
        </kendo-floatinglabel>
        <kendo-formerror *ngIf="getErrorOfField('profileInfo.birthYear', 'required') as error">
          {{ defaultErrors.required(error) }}</kendo-formerror
        >
      </kendo-formfield>
    </div>
  </div>
  <div *ngIf="current === 1">
    <div *ngIf="!formCodeShowed" class="phone-box">
      <kendo-formfield class="field-group">
        <kendo-floatinglabel class="required" text="{{ 'profile.default.phone' | localize }}">
          <kendo-maskedtextbox formControlName="login" (keydown.enter)="getCheckCode()" required></kendo-maskedtextbox>
        </kendo-floatinglabel>
        <kendo-formerror *ngIf="getErrorOfField('login', 'required') as error">
          {{ defaultErrors.required(error) }}</kendo-formerror
        >
      </kendo-formfield>
      <button class="action-button" [disabled]="isGetCodeBtnDisabled" kendoButton (click)="getCheckCode()">
        {{ 'profile.default.get_code' | localize }}
      </button>
    </div>
    <div *ngIf="formCodeShowed" class="auth-box">
      <kendo-formfield class="field-group">
        <kendo-floatinglabel class="required" text="{{ 'profile.default.hint_code' | localize }}">
          <kendo-textbox formControlName="code"></kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror *ngIf="getErrorOfField('code', 'required') as error">
          {{ defaultErrors.required(error) }}</kendo-formerror
        >
      </kendo-formfield>

      <ng-container *ngIf="countdown$ | async as value; else resend">
        {{ 'profile.default.hint_countdown' | localize }} {{ value }} {{ 'profile.default.sec' | localize }}
      </ng-container>
      <ng-template #resend>
        <button class="action-button" (click)="getCheckCode()" kendoButton>
          {{ 'profile.default.resend' | localize }}
        </button>
      </ng-template>
    </div>
  </div>
  <div *ngIf="current === 2">
    <kendo-formfield class="field-group">
      <kendo-floatinglabel class="required" text="{{ 'profile.default.password' | localize }}">
        <kendo-textbox #passwordbox formControlName="password" [clearButton]="true">
          <ng-template kendoTextBoxSuffixTemplate>
            <button
              kendoButton
              look="clear"
              iconClass="k-icon fas fa-eye"
              (click)="toggleVisibility(passwordbox)"
            ></button>
          </ng-template>
        </kendo-textbox>
      </kendo-floatinglabel>
      <kendo-formerror *ngIf="getErrorOfField('password', 'required') as error">
        {{ defaultErrors.required(error) }}
      </kendo-formerror>
      <kendo-formerror *ngIf="getErrorOfField('password', 'minlength') as error">
        {{ defaultErrors.minlength(error) }}
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formfield class="field-group">
      <kendo-floatinglabel class="required" text="{{ localizeBasePath + '.confirm_password' | localize }}">
        <kendo-textbox #cpasswordbox formControlName="confirmPassword" [clearButton]="true">
          <ng-template kendoTextBoxSuffixTemplate>
            <button
              kendoButton
              look="clear"
              iconClass="k-icon fas fa-eye"
              (click)="toggleVisibility(cpasswordbox)"
            ></button>
          </ng-template>
        </kendo-textbox>
      </kendo-floatinglabel>
      <kendo-formerror *ngIf="getErrorOfField('confirmPassword', 'required') as error">
        {{ defaultErrors.required(error) }}
      </kendo-formerror>
      <kendo-formerror *ngIf="getErrorOfField('password', 'minlength') as error">
        {{ defaultErrors.minlength(error) }}
      </kendo-formerror>
    </kendo-formfield>
    <kendo-formerror *ngIf="getErrorOfForm('custom') as error"> {{ error }}</kendo-formerror>
    <button class="action-button" [disabled]="isSendBtnDisabled" kendoButton (click)="registration()">
      <span class="k-icon k-i-loading" *ngIf="fetching; else staticText"></span>
      <ng-template #staticText>{{ 'profile.default.register' | localize }}</ng-template>
    </button>
  </div>
</form>
<button *ngIf="isValidStep(current)" class="action-button" kendoButton (click)="nextStep()">
  {{ 'profile.default.next' | localize }}
</button>
